import {Expressions} from '@packages/systems/wfdl';
import type {ExpressionElement} from '@packages/systems/wfdl-ast';
import {cacheMemo, weakMemo} from '@packages/utilities/memo';
import * as ComponentLocalizations from './ComponentLocalizations';
import type {ComponentLocalization} from './types';

export type LocalizedElementHit = {
  localizationKey: string;
  element: ExpressionElement;
};

/**
 * Finds an element that lives inside a localization value (not primary render)
 * by elementId, returning the localization key that contains it.
 */
const memoizedElementId = cacheMemo(10000);

export const findLocalizedElementById = weakMemo(
  (componentLocalization: ComponentLocalization) =>
    memoizedElementId((elementId: string): LocalizedElementHit | null => {
      for (const localizationKey in componentLocalization.definition.keys) {
        const loc = ComponentLocalizations.getLocalization(
          componentLocalization,
          localizationKey
        );
        if (!loc) continue;

        const element = Expressions.getElementById(
          ComponentLocalizations.getValueWithFallback(loc),
          elementId
        );
        if (element) {
          return {localizationKey, element};
        }
      }

      return null;
    })
);
